
    import {useStore} from "@/store";
    import checkTitle from './checkTitle.vue';
    import checkTitle1226 from './checkTitle1226.vue';
    import checkDescrip from './checkDescrip.vue';
    import checkDescrip1226 from './checkDescrip1226.vue';
    // import checkPosition from './checkPosition.vue';
    // import checkContent from './checkContent.vue';
    import checkContentDefault from './checkContentDefault.vue';
    import checkContent1226 from './checkContent1226.vue';
    import {defineComponent, ComputedRef, computed, reactive, watch} from 'vue';

    interface State {
        showDescrip: boolean;
        tocOnlyShowFlaw: boolean;
        reportDetectVersion: any;
        renderCheckContent: string;
        isRenderVersion241226: boolean;
    }
    export default defineComponent({
        name: 'checkItem',
        props: {
            renderData: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            dataIndex: {
                type: Object,
                default: -1
            }
        },
        setup() {
            let state: State = reactive({
                showDescrip: false,
                tocOnlyShowFlaw: false,
                reportDetectVersion: null,
                renderCheckContent: '',
                isRenderVersion241226: false,
            }); 
            let store = useStore();
            let version241226 = computed(() => {
                return store.state.version241226 || 0
            })
             // 格式化时间
             function formatDate(dateTime) {
                if(!dateTime) {
                    return 0;
                }
                let reg1 = /[- :]/g;
                let dateNum = Number(dateTime.replace(reg1, ''));
                return dateNum
            }
            function setRenderVersion (orderDate) {
                // state.orderDate = orderDate;
               // state.isRenderVersion241226 = formatDate(orderDate) >= version241226.value;
                state.isRenderVersion241226 = true;
                console.log('isRenderVersion241226:', state.isRenderVersion241226);
                if (state.isRenderVersion241226) {
                    state.renderCheckContent = 'checkContent1226';
                } else {
                    state.renderCheckContent = 'checkContentDefault';
                }
            }
            
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            let reportDetectVersion: ComputedRef<{}> = computed<{}>(() => store.state.reportDetectVersion)
            state.reportDetectVersion = reportDetectVersion.value;
            watch(dataInfo, (data: any) => {
                console.log('dataInfo');
                console.log(data);
                const {orderDate} = data;
                setRenderVersion(orderDate);
            }, {immediate: true})
            // let reportDetectVersion: ComputedRef<{}> = computed<{}>(() => (dataInfo as any).reportDetectVersion);
            let tocOnlyShowFlawS: ComputedRef<{}> = computed<{}>(() => store.state.tocOnlyShowFlaw)
            // state.reportDetectVersion = reportDetectVersion.value;
            watch(tocOnlyShowFlawS, (data: any) => {
                state.tocOnlyShowFlaw = data;
            }, {immediate: true})
            return {
                state
            }
        },
        components: {
            checkTitle,
            checkTitle1226,
            checkDescrip,
            checkDescrip1226,
            // checkPosition,
            checkContentDefault,
            checkContent1226,
        }
    })
